import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/closure-reasons'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'closure_reasons_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'closure_reasons_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'closure_reasons_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
